import { CardActionArea, CardContent, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import moment from "moment";
import React from "react";
import { FormattedMessage } from "react-intl";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import Number from "../../custom/Number";
import { isPremiumContract } from "../../util";

const isCanceledArchiveContract = (contract) => contract.phase === "CANCELED";

const getArchivedContractFinalizedDate = (contract) => {
  if (isCanceledArchiveContract(contract)) return null;

  if (contract.dueDate && contract.updatedAt) {
    const updatedAtBeforeDueDate = moment(contract.updatedAt).isBefore(moment(contract.dueDate), "day");
    return updatedAtBeforeDueDate ? contract.updatedAt : contract.dueDate;
  }

  return contract.dueDate || contract.updatedAt || contract.archiveDate || null;
};

const renderDateValue = (date) => (date ? <Moment date={date} format="DD/MM/YYYY" /> : "-");

const useStyles = makeStyles((theme) => ({
  cardContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  contentWrapper: {
    flexGrow: 1,
  },
  titleRow: {
    display: "flex",
    justifyContent: "space-between",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",

    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  headerType: {
    paddingRight: theme.spacing(1),
  },
  headerAmount: {
    marginLeft: "auto",
    whiteSpace: "nowrap",

    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      marginTop: theme.spacing(0.5),
    },
  },
  datesContainer: {
    marginTop: theme.spacing(1),
  },
  dateLeft: {
    textAlign: "left",
  },

  dateCenter: {
    textAlign: "left",
    [theme.breakpoints.up("md")]: {
      textAlign: "center",
    },
  },

  dateRight: {
    textAlign: "left",
    [theme.breakpoints.up("md")]: {
      textAlign: "right",
    },
  },
  chevronWrapper: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(2),
  },
}));

const ArchivedContractCard = ({ contract, currentUser }) => {
  const classes = useStyles();

  return (
    <CardActionArea disabled={currentUser.role === "KYC"} component={Link} to={`/userContract/${contract.id}`}>
      <CardContent className={classes.cardContent}>
        <div className={classes.contentWrapper}>
          <div className={classes.titleRow}>
            <Typography color={isPremiumContract(contract) ? "primary" : "textPrimary"}>{`LCContract C${contract.id}`}</Typography>

            {isPremiumContract(contract) && <Typography color="primary">Premium</Typography>}
          </div>

          <div className={classes.headerRow}>
            <Typography color="textSecondary" className={classes.headerType}>
              {contract.type.description}
            </Typography>

            {currentUser.role !== "KYC" && (
              <Typography color="textSecondary" className={classes.headerAmount}>
                <Number value={contract.amount} currency="LCT" />
              </Typography>
            )}
          </div>

          <Typography color="textSecondary">
            {contract.amount > 0 && contract.status === "INACTIVE" ? <FormattedMessage id="app.aport.validating" /> : <FormattedMessage id={`app.enuns.${contract.phase}`} />}
          </Typography>

          {!isCanceledArchiveContract(contract) && (
            <Grid container spacing={2} className={classes.datesContainer}>
              <Grid item xs={12} sm={6} md={4} className={classes.dateLeft}>
                <Typography variant="caption" color="textSecondary">
                  <FormattedMessage id="app.startDate" />
                </Typography>
                <Typography color="textPrimary">{renderDateValue(contract.initialDate)}</Typography>
              </Grid>

              <Grid item xs={12} sm={6} md={4} className={classes.dateCenter}>
                <Typography variant="caption" color="textSecondary">
                  <FormattedMessage id="app.dueDate" />
                </Typography>
                <Typography color="textPrimary">{renderDateValue(contract.dueDate)}</Typography>
              </Grid>

              <Grid item xs={12} md={4} sm={12} className={classes.dateRight}>
                <Typography variant="caption" color="textSecondary">
                  <FormattedMessage id="app.contract.finishedAt" />
                </Typography>
                <Typography color="textPrimary">{renderDateValue(getArchivedContractFinalizedDate(contract))}</Typography>
              </Grid>
            </Grid>
          )}

          {contract.splitAgent && (
            <Typography variant="caption" color="textSecondary">
              Split de <Number value={contract.splitPercent} display="percentage" /> para {contract.splitAgent.name} ({contract.splitAgent.id})
            </Typography>
          )}
        </div>

        <div className={classes.chevronWrapper}>
          <ChevronRightIcon color="action" />
        </div>
      </CardContent>
    </CardActionArea>
  );
};

export default ArchivedContractCard;
